import { Pipe, PipeTransform } from '@angular/core';
import { Request } from '../../entity/request';

@Pipe({name: 'results_filter'})
export class ResultsFilterPipe implements PipeTransform {
    transform(items: Request[], search: string): any {
        if (!items || !search) {
            return items;
        }
        // filter items array, items which match and return true will be kept, false will be filtered out
        return items.filter(item => this.match(item,search));
    }

    match(item: Request, search: string): boolean {
        let selected = false;
        if(item.number.toLowerCase().indexOf(search.toLowerCase())>-1){
            selected = true;
        }
        for(let sample of item.samples){
            if(sample.clientIdentifier && sample.clientIdentifier.toLowerCase().indexOf(search.toLowerCase())>-1){
                selected = true;
            }
            if(sample.owner && sample.owner.label.toLowerCase().indexOf(search.toLowerCase())>-1){
                selected = true;
            }
        }

        return selected;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/pipes/results-filter.pipe.ts